"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMonitoringTree = createMonitoringTree;
exports.findBestMonitoringValueForPath = findBestMonitoringValueForPath;

function hasMonitoring(module) {
  return module.dsn !== undefined || module.newRelicAppId !== undefined || module.modules && module.modules.some(function (nestedModule) {
    return hasMonitoring(nestedModule);
  });
}

function createMonitoringTree(module) {
  if (!hasMonitoring(module)) {
    return null;
  }

  var pathname = module._path.toJS().join('/');

  if (module.modules) {
    var moduleTrees = module.modules.reduce(function (acc, nestedModule) {
      if (hasMonitoring(nestedModule)) {
        acc.push(createMonitoringTree(nestedModule));
      }

      return acc;
    }, []);
    return Object.assign({
      pathname: pathname,
      dsn: module.dsn,
      newRelicAppId: module.newRelicAppId
    }, moduleTrees.length ? {
      modules: moduleTrees
    } : null);
  }

  return {
    pathname: pathname,
    dsn: module.dsn,
    newRelicAppId: module.newRelicAppId
  };
}

function findBestMonitoringValueForPath(monitoringProperty, monitoringTree, pathname, fallbackValue) {
  if (!pathname.includes(monitoringTree.pathname)) {
    return fallbackValue;
  }

  if (monitoringTree.modules) {
    var nestedValue = monitoringTree.modules.map(function (nestedModule) {
      return findBestMonitoringValueForPath(monitoringProperty, nestedModule, pathname, null);
    }).find(function (value) {
      return value;
    }); //Finds the first defined value

    if (nestedValue) {
      return nestedValue;
    }
  }

  return monitoringTree[monitoringProperty] || fallbackValue;
}